export default "__VITE_ASSET__CL69A0TR__"